/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { SettlementPeopleList } from './types';

enum Api {
  settlementPeopleList = '/front-end/api/v1/project/settlement/people', // 【项目人员】 列表
  settlementAudit = '/front-end/api/v1/project/settlement/audit', // 【项目人员】审核资质
  settlementSurvey = '/front-end/api/v1/project/settlement/survey' // 【项目人员】审核资质
}

export const settlementPeopleList: SettlementPeopleList = params =>
  http.request({
    url: Api.settlementPeopleList,
    method: 'POST',
    params
  });

export const settlementAudit = (params: {
  applyId: number;
  auditStatus: number;
  auditRemark?: string;
}) =>
  http.request({
    url: Api.settlementAudit,
    method: 'POST',
    params
  });

export const settlementSurvey = (params: {
  applyId: number;
}): Promise<
  Result<
    {
      question: string; //问题
      answer: string; //答案
    }[]
  >
> =>
  http.request({
    url: Api.settlementSurvey + `/${params.applyId}`,
    method: 'GET'
  });
